import {v4 as uuidv4} from "uuid";
import {CSV_MODE_DEFAULT, STEP_COLUMN, STEP_FILE} from "../../components/etl-wizard/constants";
import {USER_MANAGED_CSV_BAD_DATA} from "../../translations/getManagedErrorsTranslations";
import {NODE_FETCH} from "../node/nodeActions";
import {USER_CLEAR, USER_FETCH, USER_LOGOUT} from "../user/userActions";
import {
  PACKAGE_MANAGER_AGENT_CREATE,
  PACKAGE_MANAGER_AGENT_DELETE,
  PACKAGE_MANAGER_AGENT_GET,
  PACKAGE_MANAGER_AGENT_HIDE,
  PACKAGE_MANAGER_AGENT_LIST_FETCH,
  PACKAGE_MANAGER_AGENT_LIST_HIDE,
  PACKAGE_MANAGER_AGENT_LIST_SHOW,
  PACKAGE_MANAGER_AGENT_SCHEMA_FETCH,
  PACKAGE_MANAGER_AGENT_SHOW,
  PACKAGE_MANAGER_AGENT_UPDATE,
  PACKAGE_MANAGER_CATALOG_RELOAD,
  PACKAGE_MANAGER_EASY_LOADING_DATASET_SET,
  PACKAGE_MANAGER_EASY_LOADING_ORGANIZATIONS_GET,
  PACKAGE_MANAGER_EASY_LOADING_PACKAGE_LICENSE_GET,
  PACKAGE_MANAGER_EASY_LOADING_RESOURCE_LICENSE_GET,
  PACKAGE_MANAGER_EASY_LOADING_RESOURCE_SET,
  PACKAGE_MANAGER_EASY_LOADING_SUBMIT_ERROR,
  PACKAGE_MANAGER_EASY_LOADING_SUBMIT_SUCCESS,
  PACKAGE_MANAGER_EASY_LOADING_THEMES_GET,
  PACKAGE_MANAGER_EASY_LOADING_WMS_MODAL_HIDE,
  PACKAGE_MANAGER_EASY_LOADING_WMS_MODAL_SHOW,
  PACKAGE_MANAGER_ETL_WIZARD_CODELIST_GET,
  PACKAGE_MANAGER_ETL_WIZARD_COLUMNS_SET,
  PACKAGE_MANAGER_ETL_WIZARD_CSV_FORMAT_SET,
  PACKAGE_MANAGER_ETL_WIZARD_ERROR_SET,
  PACKAGE_MANAGER_ETL_WIZARD_MODAL_HIDE,
  PACKAGE_MANAGER_ETL_WIZARD_MODAL_SHOW,
  PACKAGE_MANAGER_ETL_WIZARD_MODAL_SUBMIT,
  PACKAGE_MANAGER_ETL_WIZARD_REPORT_HIDE,
  PACKAGE_MANAGER_ETL_WIZARD_STEP_SET,
  PACKAGE_MANAGER_ETL_WIZARD_STRUCTURE_GET,
  PACKAGE_MANAGER_PACKAGE_APPROVE,
  PACKAGE_MANAGER_PACKAGE_CREATE,
  PACKAGE_MANAGER_PACKAGE_DELETE,
  PACKAGE_MANAGER_PACKAGE_DISAPPROVE,
  PACKAGE_MANAGER_PACKAGE_GET,
  PACKAGE_MANAGER_PACKAGE_HIDE,
  PACKAGE_MANAGER_PACKAGE_LICENSE_CREATE,
  PACKAGE_MANAGER_PACKAGE_LICENSE_DELETE,
  PACKAGE_MANAGER_PACKAGE_LICENSE_GET,
  PACKAGE_MANAGER_PACKAGE_LICENSE_HIDE,
  PACKAGE_MANAGER_PACKAGE_LICENSE_LIST_FETCH,
  PACKAGE_MANAGER_PACKAGE_LICENSE_LIST_HIDE,
  PACKAGE_MANAGER_PACKAGE_LICENSE_LIST_SHOW,
  PACKAGE_MANAGER_PACKAGE_LICENSE_SCHEMA_FETCH,
  PACKAGE_MANAGER_PACKAGE_LICENSE_SHOW,
  PACKAGE_MANAGER_PACKAGE_LICENSE_UPDATE,
  PACKAGE_MANAGER_PACKAGE_LIST_FETCH,
  PACKAGE_MANAGER_PACKAGE_LIST_HIDE,
  PACKAGE_MANAGER_PACKAGE_LIST_SHOW,
  PACKAGE_MANAGER_PACKAGE_OWNERSHIP_FETCH,
  PACKAGE_MANAGER_PACKAGE_OWNERSHIP_SET,
  PACKAGE_MANAGER_PACKAGE_SCHEMA_FETCH,
  PACKAGE_MANAGER_PACKAGE_SHOW,
  PACKAGE_MANAGER_PACKAGE_UPDATE,
  PACKAGE_MANAGER_RESOURCE_CREATE,
  PACKAGE_MANAGER_RESOURCE_DELETE,
  PACKAGE_MANAGER_RESOURCE_GET,
  PACKAGE_MANAGER_RESOURCE_HIDE,
  PACKAGE_MANAGER_RESOURCE_LICENSE_CREATE,
  PACKAGE_MANAGER_RESOURCE_LICENSE_DELETE,
  PACKAGE_MANAGER_RESOURCE_LICENSE_GET,
  PACKAGE_MANAGER_RESOURCE_LICENSE_HIDE,
  PACKAGE_MANAGER_RESOURCE_LICENSE_LIST_FETCH,
  PACKAGE_MANAGER_RESOURCE_LICENSE_LIST_HIDE,
  PACKAGE_MANAGER_RESOURCE_LICENSE_LIST_SHOW,
  PACKAGE_MANAGER_RESOURCE_LICENSE_SCHEMA_FETCH,
  PACKAGE_MANAGER_RESOURCE_LICENSE_SHOW,
  PACKAGE_MANAGER_RESOURCE_LICENSE_UPDATE,
  PACKAGE_MANAGER_RESOURCE_LIST_HIDE,
  PACKAGE_MANAGER_RESOURCE_LIST_SHOW,
  PACKAGE_MANAGER_RESOURCE_SCHEMA_FETCH,
  PACKAGE_MANAGER_RESOURCE_SHOW,
  PACKAGE_MANAGER_RESOURCE_UPDATE,
  PACKAGE_MANAGER_STATE_CLEAR,
  PACKAGE_MANAGER_THEME_CREATE,
  PACKAGE_MANAGER_THEME_DELETE,
  PACKAGE_MANAGER_THEME_GET,
  PACKAGE_MANAGER_THEME_HIDE,
  PACKAGE_MANAGER_THEME_LIST_FETCH,
  PACKAGE_MANAGER_THEME_LIST_HIDE,
  PACKAGE_MANAGER_THEME_LIST_SHOW,
  PACKAGE_MANAGER_THEME_SCHEMA_FETCH,
  PACKAGE_MANAGER_THEME_SHOW,
  PACKAGE_MANAGER_THEME_UPDATE
} from "./packageManagerActions";
import {getActionExtras} from "../../middlewares/action-decorator/middlewareFactory";
import {REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS} from "../../middlewares/request/requestActions";
import {parseColumnDefinitions} from "../../components/etl-wizard/utils";
import EXTRAS from "../../utils/extras";
import {localizeI18nObj} from "../../utils/i18n";

const removeInternalKeys = obj => {
  if (obj === null || obj === undefined || typeof obj !== "object") {
    return obj;
  }
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (!key.startsWith("__")) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

const findItemByFields = (list, values = [], fields = []) => {
  const normalized = new Set(values.map(v => v?.toLowerCase?.()));
  return list?.find(item => fields.some(f => normalized.has(item[f]?.toLowerCase?.())));
};

const agentsManagerInitialState = {
  isVisible: false,
  schema: null,
  uiSchema: null,
  agents: null,
  agentId: null,
  agent: null
};

const themesManagerInitialState = {
  isVisible: false,
  schema: null,
  uiSchema: null,
  themes: null,
  themeId: null,
  theme: null
};

const packageLicensesManagerInitialState = {
  isVisible: false,
  schema: null,
  uiSchema: null,
  packageLicenses: null,
  packageLicenseId: null,
  packageLicense: null
};

const resourceLicensesManagerInitialState = {
  isVisible: false,
  schema: null,
  uiSchema: null,
  resourceLicenses: null,
  resourceLicenseId: null,
  resourceLicense: null
};

const etlInitialState = {
  isVisible: false,
  isEditMode: false,
  isReportVisible: false,
  enableFileUpload: false,
  packageTitle: null,
  step: null,
  errorMessage: null,
  csvFormat: {
    delimiter: null,
    quote: null,
    escape: null,
    csvMode: CSV_MODE_DEFAULT
  },
  isCsvFormatDialogOpen: false,
  columns: [],
  codelist: null,
  importResult: null,
  initialSuggestions: {},
  dateFormats: null
};

const easyLoadingInitialState = {
  themes: null,
  organizations: null,
  packageLicenses: null,
  resourceLicenses: null,
  dataset: null,
  resource: null
};

const initialState = {
  readOnly: false,
  isPackageListModalVisible: false,
  isPackageSettingsModalVisible: false,
  isResourceListModalVisible: false,
  isResourceSettingsModalVisible: false,
  reloadCatalog: false,

  nodeId: null,
  nodeCode: null,
  packages: null,

  packageSchema: null,
  packageUiSchema: null,
  packageId: null,
  package: null,

  resourceSchema: null,
  resourceUiSchema: null,
  resourceId: null,
  resource: null,

  agentsManager: agentsManagerInitialState,
  themesManager: themesManagerInitialState,
  packageLicensesManager: packageLicensesManagerInitialState,
  resourceLicensesManager: resourceLicensesManagerInitialState,
  etl: etlInitialState,
  easyLoading: easyLoadingInitialState,
  wmsIsVisible: false,
  wmsIsImported: null
};

const packageManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case PACKAGE_MANAGER_STATE_CLEAR:
      return {
        ...initialState
      };
    case PACKAGE_MANAGER_CATALOG_RELOAD:
      return {
        ...state,
        reloadCatalog: true
      };

    case PACKAGE_MANAGER_PACKAGE_LIST_SHOW:
      return {
        ...state,
        isPackageListModalVisible: true,
        nodeId: action.payload.nodeId,
        nodeCode: action.payload.nodeCode,
        readOnly: action.payload.readOnly
      };
    case PACKAGE_MANAGER_PACKAGE_LIST_HIDE:
      return {
        ...initialState
      };
    case PACKAGE_MANAGER_PACKAGE_OWNERSHIP_SET:
      return {
        ...state,
        packagesOwnerMap: new Map()
      };
    case PACKAGE_MANAGER_PACKAGE_SHOW:
      return {
        ...state,
        isPackageSettingsModalVisible: true,
        packageId: action.payload.packageId || null,
        package: action.payload.packageId
          ? null
          : {
              Public: true,
              Themes: [""],
              Identifier: uuidv4()
            }
      };
    case PACKAGE_MANAGER_PACKAGE_HIDE:
      return {
        ...state,
        isPackageSettingsModalVisible: false,
        packageId: null,
        package: null
      };

    case PACKAGE_MANAGER_RESOURCE_LIST_SHOW:
      return {
        ...state,
        isResourceListModalVisible: true,
        packageId: action.payload.packageId
      };
    case PACKAGE_MANAGER_RESOURCE_LIST_HIDE:
      return {
        ...state,
        isResourceListModalVisible: false,
        packageId: null
      };
    case PACKAGE_MANAGER_RESOURCE_SHOW:
      return {
        ...state,
        isResourceSettingsModalVisible: true,
        resourceId: action.payload.resourceId || null,
        resource: action.payload.resourceId
          ? null
          : {
              Packages: [state.packageId],
              Public: true
            }
      };
    case PACKAGE_MANAGER_RESOURCE_HIDE:
      return {
        ...state,
        isResourceSettingsModalVisible: false,
        resourceId: null,
        resource: null
      };

    case PACKAGE_MANAGER_AGENT_LIST_SHOW: {
      return {
        ...state,
        agentsManager: {
          ...agentsManagerInitialState,
          isVisible: true
        }
      };
    }
    case PACKAGE_MANAGER_AGENT_LIST_HIDE: {
      return {
        ...state,
        agentsManager: agentsManagerInitialState
      };
    }
    case PACKAGE_MANAGER_AGENT_SHOW: {
      return {
        ...state,
        agentsManager: {
          ...state.agentsManager,
          agent: {
            Identifier: uuidv4()
          }
        }
      };
    }
    case PACKAGE_MANAGER_AGENT_HIDE: {
      return {
        ...state,
        agentsManager: {
          ...state.agentsManager,
          agentId: null,
          agent: null
        }
      };
    }

    case PACKAGE_MANAGER_THEME_LIST_SHOW: {
      return {
        ...state,
        themesManager: {
          ...themesManagerInitialState,
          isVisible: true
        }
      };
    }
    case PACKAGE_MANAGER_THEME_LIST_HIDE: {
      return {
        ...state,
        themesManager: themesManagerInitialState
      };
    }
    case PACKAGE_MANAGER_THEME_SHOW: {
      return {
        ...state,
        themesManager: {
          ...state.themesManager,
          theme: {
            Public: true
          }
        }
      };
    }
    case PACKAGE_MANAGER_THEME_HIDE: {
      return {
        ...state,
        themesManager: {
          ...state.themesManager,
          themeId: null,
          theme: null
        }
      };
    }

    case PACKAGE_MANAGER_PACKAGE_LICENSE_LIST_SHOW: {
      return {
        ...state,
        packageLicensesManager: {
          ...packageLicensesManagerInitialState,
          isVisible: true
        }
      };
    }
    case PACKAGE_MANAGER_PACKAGE_LICENSE_LIST_HIDE: {
      return {
        ...state,
        packageLicensesManager: packageLicensesManagerInitialState
      };
    }
    case PACKAGE_MANAGER_PACKAGE_LICENSE_SHOW: {
      return {
        ...state,
        packageLicensesManager: {
          ...state.packageLicensesManager,
          packageLicense: {
            Identifier: uuidv4()
          }
        }
      };
    }
    case PACKAGE_MANAGER_PACKAGE_LICENSE_HIDE: {
      return {
        ...state,
        packageLicensesManager: {
          ...state.packageLicensesManager,
          packageLicenseId: null,
          packageLicense: null
        }
      };
    }

    case PACKAGE_MANAGER_RESOURCE_LICENSE_LIST_SHOW: {
      return {
        ...state,
        resourceLicensesManager: {
          ...resourceLicensesManagerInitialState,
          isVisible: true
        }
      };
    }
    case PACKAGE_MANAGER_RESOURCE_LICENSE_LIST_HIDE: {
      return {
        ...state,
        resourceLicensesManager: resourceLicensesManagerInitialState
      };
    }
    case PACKAGE_MANAGER_RESOURCE_LICENSE_SHOW: {
      return {
        ...state,
        resourceLicensesManager: {
          ...state.resourceLicensesManager,
          resourceLicense: {
            Identifier: uuidv4()
          }
        }
      };
    }
    case PACKAGE_MANAGER_RESOURCE_LICENSE_HIDE: {
      return {
        ...state,
        resourceLicensesManager: {
          ...state.resourceLicensesManager,
          resourceLicenseId: null,
          resourceLicense: null
        }
      };
    }

    case PACKAGE_MANAGER_ETL_WIZARD_MODAL_SHOW:
      return {
        ...state,
        packageId: action.payload.packageId ?? state.packageId,
        resourceId: action.payload.resourceId,
        nodeId: action.payload.nodeId ?? state.nodeId,
        nodeCode: action.payload.nodeCode ?? state.nodeCode,
        etl: {
          ...state.etl,
          isVisible: true,
          isEditMode: action.payload.isEditMode,
          step: !action.payload.resourceId ? STEP_FILE : STEP_COLUMN,
          enableFileUpload: !action.payload.resourceId,
          packageTitle: action.payload.packageTitle
        }
      };
    case PACKAGE_MANAGER_ETL_WIZARD_MODAL_HIDE:
      return {
        ...state,
        packageId: state.isPackageListModalVisible ? state.packageId : null,
        resourceId: null,
        etl: {
          ...etlInitialState
        },
        easyLoading: {
          ...easyLoadingInitialState
        }
      };
    case PACKAGE_MANAGER_ETL_WIZARD_REPORT_HIDE:
      return state.etl?.importResult?.dataImported
        ? {
            ...state,
            packageId: state.isPackageListModalVisible ? state.packageId : null,
            resourceId: null,
            etl: {
              ...etlInitialState
            },
            easyLoading: {
              ...easyLoadingInitialState
            }
          }
        : {
            ...state,
            etl: {
              ...state.etl,
              isReportVisible: false
            }
          };
    case PACKAGE_MANAGER_ETL_WIZARD_STEP_SET:
      return {
        ...state,
        etl: {
          ...state.etl,
          step: action.payload.step
        }
      };
    case PACKAGE_MANAGER_EASY_LOADING_DATASET_SET:
      return {
        ...state,
        easyLoading: {
          ...state.easyLoading,
          dataset: action.payload.dataset
        }
      };
    case PACKAGE_MANAGER_EASY_LOADING_RESOURCE_SET:
      return {
        ...state,
        easyLoading: {
          ...state.easyLoading,
          resource: action.payload.resource
        }
      };
    case PACKAGE_MANAGER_ETL_WIZARD_COLUMNS_SET:
      return {
        ...state,
        etl: {
          ...state.etl,
          columns: action.payload.columns
        }
      };
    case PACKAGE_MANAGER_ETL_WIZARD_ERROR_SET:
      return {
        ...state,
        etl: {
          ...state.etl,
          errorMessage: action.payload.errorMessage
        }
      };
    case PACKAGE_MANAGER_ETL_WIZARD_CSV_FORMAT_SET:
      return {
        ...state,
        etl: {
          ...state.etl,
          csvFormat: action.payload.csvFormat
        }
      };
    case PACKAGE_MANAGER_EASY_LOADING_WMS_MODAL_SHOW:
      return {
        ...state,
        wmsIsVisible: true,
        easyLoading: {
          ...state.easyLoading,
          resource: {
            ...state.easyLoading.resource,
            format: "WMS"
          }
        }
      };
    case PACKAGE_MANAGER_EASY_LOADING_WMS_MODAL_HIDE:
      return {
        ...state,
        wmsIsVisible: false,
        wmsIsImported: false,
        easyLoading: {
          ...easyLoadingInitialState
        }
      };

    case PACKAGE_MANAGER_EASY_LOADING_SUBMIT_SUCCESS:
      return {
        ...state,
        packageId: action.payload.packageId,
        resourceId: action.payload.resourceId,
        etl: {
          ...state.etl,
          step: state.etl?.isVisible ? STEP_COLUMN : state.etl.step
        },
        wmsIsImported: state.wmsIsVisible ? true : null
      };
    case PACKAGE_MANAGER_EASY_LOADING_SUBMIT_ERROR:
      return {
        ...state,
        wmsIsImported: state.wmsIsVisible ? false : null
      };
    case REQUEST_START: {
      switch (action.payload.label) {
        case PACKAGE_MANAGER_ETL_WIZARD_STRUCTURE_GET:
          return {
            ...state,
            etl: {
              ...state.etl,
              isCsvFormatDialogOpen: false
            }
          };
        default:
          return state;
      }
    }
    case REQUEST_SUCCESS: {
      switch (action.payload.label) {
        case PACKAGE_MANAGER_PACKAGE_OWNERSHIP_FETCH: {
          const ownerMap = new Map((action.payload.response || []).map(item => [item.__Guid, item.__OwnerId]));
          return {
            ...state,
            packagesOwnerMap: ownerMap
          };
        }
        case PACKAGE_MANAGER_PACKAGE_LIST_FETCH: {
          const {language, languages} = getActionExtras(action);
          const packageMap = action.payload.response?.packageMap;
          const resourceMap = action.payload.response?.resourceMap;

          const packages = Object.entries(packageMap).map(([key, value]) => {
            const linkedResources = {};
            const resources = value.resourceIdentifiers.map(resId => {
              const extras = EXTRAS.parse(resourceMap[resId]?.extras, language, languages);
              let isLinkedResource = false;
              if (extras.StructuredFrom) {
                isLinkedResource = true;
                linkedResources[extras.StructuredFrom] = linkedResources[extras.StructuredFrom] ?? [];
                linkedResources[extras.StructuredFrom].push(resId);
              }
              return {
                id: resId,
                title: resourceMap[resId]?.title,
                type: resourceMap[resId]?.type,
                isLinkedResource: isLinkedResource
              };
            });

            return {
              id: key,
              title: value.title,
              public: value.public,
              resources: resources,
              linkedResources: linkedResources,
              owner: state.packagesOwnerMap?.get(key) ?? null
            };
          });

          return {
            ...state,
            packages: packages
          };
        }
        case PACKAGE_MANAGER_PACKAGE_SCHEMA_FETCH: {
          return {
            ...state,
            packageSchema: {
              properties: action.payload.response?.value?.properties,
              required: action.payload.response?.value?.required || [],
              type: action.payload.response?.value?.type || "object"
            },
            packageUiSchema: action.payload.response?.value?.uiSchema
          };
        }
        case PACKAGE_MANAGER_PACKAGE_GET: {
          return {
            ...state,
            package: removeInternalKeys(action.payload.response)
          };
        }
        case PACKAGE_MANAGER_PACKAGE_CREATE:
        case PACKAGE_MANAGER_PACKAGE_DELETE: {
          return {
            ...state,
            isPackageSettingsModalVisible: false,
            reloadCatalog: true,
            packagesOwnerMap: null,
            packages: null,
            packageId: null,
            package: null
          };
        }
        case PACKAGE_MANAGER_PACKAGE_UPDATE:
        case PACKAGE_MANAGER_PACKAGE_APPROVE:
        case PACKAGE_MANAGER_PACKAGE_DISAPPROVE: {
          return {
            ...state,
            isPackageSettingsModalVisible: false,
            reloadCatalog: true,
            packages: null,
            packageId: null,
            package: null
          };
        }

        case PACKAGE_MANAGER_RESOURCE_SCHEMA_FETCH: {
          return {
            ...state,
            resourceSchema: {
              properties: action.payload.response?.value?.properties,
              required: action.payload.response?.value?.required || [],
              type: action.payload.response?.value?.type || "object"
            },
            resourceUiSchema: action.payload.response?.value?.uiSchema
          };
        }
        case PACKAGE_MANAGER_RESOURCE_GET: {
          return {
            ...state,
            resource: removeInternalKeys(action.payload.response)
          };
        }
        case PACKAGE_MANAGER_RESOURCE_CREATE:
        case PACKAGE_MANAGER_RESOURCE_UPDATE:
        case PACKAGE_MANAGER_RESOURCE_DELETE: {
          return {
            ...state,
            isResourceSettingsModalVisible: false,
            reloadCatalog: true,
            packages: null,
            resource: null
          };
        }

        case PACKAGE_MANAGER_AGENT_LIST_FETCH: {
          return {
            ...state,
            agentsManager: {
              ...state.agentsManager,
              agents: action.payload.response
            }
          };
        }
        case PACKAGE_MANAGER_AGENT_SCHEMA_FETCH: {
          return {
            ...state,
            agentsManager: {
              ...state.agentsManager,
              schema: {
                properties: action.payload.response?.value?.properties,
                required: action.payload.response?.value?.required || [],
                type: action.payload.response?.value?.type || "object"
              },
              uiSchema: action.payload.response?.value?.uiSchema
            }
          };
        }
        case PACKAGE_MANAGER_AGENT_GET: {
          return {
            ...state,
            agentsManager: {
              ...state.agentsManager,
              agentId: action.payload.extra.agentId,
              agent: removeInternalKeys(action.payload.response)
            }
          };
        }
        case PACKAGE_MANAGER_AGENT_CREATE:
        case PACKAGE_MANAGER_AGENT_UPDATE:
        case PACKAGE_MANAGER_AGENT_DELETE: {
          return {
            ...state,
            agentsManager: {
              ...state.agentsManager,
              agents: null,
              agentId: null,
              agent: null
            }
          };
        }

        case PACKAGE_MANAGER_THEME_LIST_FETCH: {
          return {
            ...state,
            themesManager: {
              ...state.themesManager,
              themes: action.payload.response
            }
          };
        }
        case PACKAGE_MANAGER_THEME_SCHEMA_FETCH: {
          return {
            ...state,
            themesManager: {
              ...state.themesManager,
              schema: {
                properties: action.payload.response?.value?.properties,
                required: action.payload.response?.value?.required || [],
                type: action.payload.response?.value?.type || "object"
              },
              uiSchema: action.payload.response?.value?.uiSchema
            }
          };
        }
        case PACKAGE_MANAGER_THEME_GET: {
          return {
            ...state,
            themesManager: {
              ...state.themesManager,
              themeId: action.payload.extra.themeId,
              theme: removeInternalKeys(action.payload.response)
            }
          };
        }
        case PACKAGE_MANAGER_THEME_CREATE:
        case PACKAGE_MANAGER_THEME_UPDATE:
        case PACKAGE_MANAGER_THEME_DELETE: {
          return {
            ...state,
            themesManager: {
              ...state.themesManager,
              schema: null,
              uiSchema: null,
              themes: null,
              themeId: null,
              theme: null
            }
          };
        }

        case PACKAGE_MANAGER_PACKAGE_LICENSE_LIST_FETCH: {
          return {
            ...state,
            packageLicensesManager: {
              ...state.packageLicensesManager,
              packageLicenses: action.payload.response
            }
          };
        }
        case PACKAGE_MANAGER_PACKAGE_LICENSE_SCHEMA_FETCH: {
          return {
            ...state,
            packageLicensesManager: {
              ...state.packageLicensesManager,
              schema: {
                properties: action.payload.response?.value?.properties,
                required: action.payload.response?.value?.required || [],
                type: action.payload.response?.value?.type || "object"
              },
              uiSchema: action.payload.response?.value?.uiSchema
            }
          };
        }
        case PACKAGE_MANAGER_PACKAGE_LICENSE_GET: {
          return {
            ...state,
            packageLicensesManager: {
              ...state.packageLicensesManager,
              packageLicenseId: action.payload.extra.packageLicenseId,
              packageLicense: removeInternalKeys(action.payload.response)
            }
          };
        }
        case PACKAGE_MANAGER_PACKAGE_LICENSE_CREATE:
        case PACKAGE_MANAGER_PACKAGE_LICENSE_UPDATE:
        case PACKAGE_MANAGER_PACKAGE_LICENSE_DELETE: {
          return {
            ...state,
            packageLicensesManager: {
              ...state.packageLicensesManager,
              schema: null,
              uiSchema: null,
              packageLicenses: null,
              packageLicenseId: null,
              packageLicense: null
            }
          };
        }

        case PACKAGE_MANAGER_RESOURCE_LICENSE_LIST_FETCH: {
          return {
            ...state,
            resourceLicensesManager: {
              ...state.resourceLicensesManager,
              resourceLicenses: action.payload.response
            }
          };
        }
        case PACKAGE_MANAGER_RESOURCE_LICENSE_SCHEMA_FETCH: {
          return {
            ...state,
            resourceLicensesManager: {
              ...state.resourceLicensesManager,
              schema: {
                properties: action.payload.response?.value?.properties,
                required: action.payload.response?.value?.required || [],
                type: action.payload.response?.value?.type || "object"
              },
              uiSchema: action.payload.response?.value?.uiSchema
            }
          };
        }
        case PACKAGE_MANAGER_RESOURCE_LICENSE_GET: {
          return {
            ...state,
            resourceLicensesManager: {
              ...state.resourceLicensesManager,
              resourceLicenseId: action.payload.extra.resourceLicenseId,
              resourceLicense: removeInternalKeys(action.payload.response)
            }
          };
        }
        case PACKAGE_MANAGER_RESOURCE_LICENSE_CREATE:
        case PACKAGE_MANAGER_RESOURCE_LICENSE_UPDATE:
        case PACKAGE_MANAGER_RESOURCE_LICENSE_DELETE: {
          return {
            ...state,
            resourceLicensesManager: {
              ...state.resourceLicensesManager,
              schema: null,
              uiSchema: null,
              resourceLicenses: null,
              resourceLicenseId: null,
              resourceLicense: null
            }
          };
        }

        case PACKAGE_MANAGER_EASY_LOADING_THEMES_GET: {
          const {language, languages} = getActionExtras(action);

          const themes = action.payload.response.map(theme => ({
            id: theme.__Guid,
            label: localizeI18nObj(theme.__DisplayName || theme.title, language, languages),
            parent: theme.parent || null
          }));

          return {
            ...state,
            easyLoading: {
              ...state.easyLoading,
              themes: themes,
              dataset: {
                ...state.easyLoading.dataset,
                theme: findItemByFields(themes, ["altro", "other"], ["id", "label"])?.id ?? null
              }
            }
          };
        }
        case PACKAGE_MANAGER_EASY_LOADING_ORGANIZATIONS_GET: {
          const {language, languages} = getActionExtras(action);

          const organizations = action.payload.response.map(org => ({
            id: org.__Guid,
            label: localizeI18nObj(org.__DisplayName || org.title, language, languages)
          }));

          return {
            ...state,
            easyLoading: {
              ...state.easyLoading,
              organizations: organizations,
              dataset: {
                ...state.easyLoading.dataset,
                organization:
                  findItemByFields(organizations, ["altro", "other"], ["id", "label"])?.id ??
                  organizations[0]?.id ??
                  null
              }
            }
          };
        }
        case PACKAGE_MANAGER_EASY_LOADING_PACKAGE_LICENSE_GET: {
          const {language, languages} = getActionExtras(action);

          const licenses = action.payload.response.map(license => ({
            id: license.__Guid,
            label: localizeI18nObj(license.__DisplayName || license.title, language, languages),
            parent: license.parent
          }));

          return {
            ...state,
            easyLoading: {
              ...state.easyLoading,
              packageLicenses: licenses,
              dataset: {
                ...state.easyLoading.dataset,
                license:
                  findItemByFields(licenses, ["non specificato", "not specified"], ["id", "label"])?.id ??
                  licenses[0]?.id ??
                  null
              }
            }
          };
        }
        case PACKAGE_MANAGER_EASY_LOADING_RESOURCE_LICENSE_GET: {
          const {language, languages} = getActionExtras(action);

          const licenses = action.payload.response.map(license => ({
            id: license.__Guid,
            label: localizeI18nObj(license.__DisplayName || license.title, language, languages),
            parent: license.parent
          }));

          return {
            ...state,
            easyLoading: {
              ...state.easyLoading,
              resourceLicenses: licenses,
              resource: {
                ...state.easyLoading.resource,
                license:
                  findItemByFields(licenses, ["non specificato", "not specified"], ["id", "label"])?.id ??
                  licenses[0]?.id ??
                  null
              }
            }
          };
        }
        case PACKAGE_MANAGER_ETL_WIZARD_STRUCTURE_GET: {
          const columns = parseColumnDefinitions(action.payload.response?.importColumnsDefinitions);
          const dateFormats = action.payload.response?.dateFormats;
          const csvFormat = action.payload.response?.csvFormat;

          const initialSuggestions = {};
          columns.forEach(column => {
            initialSuggestions[column.name] = {...column};
          });

          return {
            ...state,
            etl: {
              ...state.etl,
              columns: columns,
              initialSuggestions: initialSuggestions,
              dateFormats: dateFormats,
              csvFormat: csvFormat ?? state.etl.csvFormat,
              isCsvFormatDialogOpen: false
            }
          };
        }
        case PACKAGE_MANAGER_ETL_WIZARD_CODELIST_GET: {
          const {language, languages} = getActionExtras(action);
          const parsedResponse = (action.payload.response || []).map(codelist => ({
            ...codelist,
            ...EXTRAS.parse(codelist.Extras, language, languages),
            label: localizeI18nObj(codelist.Names, language, languages)
          }));

          return {
            ...state,
            etl: {
              ...state.etl,
              codelist: parsedResponse
            }
          };
        }
        case PACKAGE_MANAGER_ETL_WIZARD_MODAL_SUBMIT: {
          const importResult = action.payload.response;

          if (importResult?.dimensionsDuplicatedRows) {
            const dimensionsDuplicatedRows = importResult.dimensionsDuplicatedRows.map(row => ({
              rowNumbers: row.rowNumbers.join(),
              ...row.fieldsValues
            }));
            importResult.dimensionsDuplicatedRows = dimensionsDuplicatedRows;
          }

          if (importResult?.fullDuplicatedRows) {
            const fullDuplicatedRows = importResult.fullDuplicatedRows.map(row => ({
              rowNumbers: row.rowNumbers.join(),
              ...row.fieldsValues
            }));
            importResult.fullDuplicatedRows = fullDuplicatedRows;
          }

          return {
            ...state,
            etl: {
              ...state.etl,
              isReportVisible: true,
              importResult: importResult,
              isVisible: !importResult.dataImported
            }
          };
        }
        case NODE_FETCH:
        case USER_FETCH:
        case USER_CLEAR:
        case USER_LOGOUT: {
          return {
            ...initialState
          };
        }
        default:
          return state;
      }
    }
    case REQUEST_ERROR: {
      switch (action.payload.label) {
        case PACKAGE_MANAGER_ETL_WIZARD_STRUCTURE_GET: {
          return {
            ...state,
            etl: {
              ...state.etl,
              isCsvFormatDialogOpen: action.payload.response.errorCode === USER_MANAGED_CSV_BAD_DATA
            }
          };
        }
        case PACKAGE_MANAGER_ETL_WIZARD_CODELIST_GET: {
          return {
            ...state,
            etl: {
              ...state.etl,
              codelist: []
            }
          };
        }
        default:
          return state;
      }
    }
    default:
      return state;
  }
};

export default packageManagerReducer;
